export default {
  'Welcome to the materialflows quiz': 'Welcome to the materialflows quiz',
  'Start quiz': 'Start quiz',
  'Please choose at least one topic.': 'Please choose at least one topic.',
  'Language': 'Language',
  'German': 'German',
  'English': 'English',
  'Mode': 'Mode',
  'Presentation mode': 'Presentation mode',
  'Topics': 'Topics',
  'Configuration': 'Configuration',
  'Question': 'Question',
  'of': 'of',
  'Final result': 'Final result',
  'Skip question': 'Skip question',
  'More info': 'More info',
  'Continue': 'Continue',
  'Congratulations': 'Congratulations',
  'You have correctly answered <span class=\'text-primary\'>{0} of {1}</span> questions!': 'You have correctly answered <span class=\'text-primary\'>{0} of {1}</span> questions!',
  'for a better understanding of the world of raw materials!': 'for a better understanding of the world of raw materials!',
  'Restart quiz': 'Restart quiz',
  'Visit materialflows.net': 'Visit materialflows.net',
  'Result': 'Result'
}



// WEBPACK FOOTER //
// ./src/locale/en.js